import { createApi } from "@reduxjs/toolkit/query/react";
import { EnrolledBeneficiaryType } from "../types/beneficiaries";
import { customBaseQuery } from "./customBaseQuery";

export const beneficiaryApi = createApi({
  reducerPath: "beneficiaryApi",
  baseQuery: customBaseQuery as any,
  tagTypes: ["Beneficiary", "Performance"],
  endpoints: (builder) => ({
    getIndividualBeneficiary: builder.query<EnrolledBeneficiaryType, string>({
      query: (accountNumber) => ({
        url: `/Account/investment-summary-by-benificiary/${accountNumber}`,
      }),
      providesTags: (_result, _error, accountNumber) => [
        { type: "Beneficiary", id: accountNumber },
      ],
    }),
    getBeneficiaryPerformance: builder.query<
      any,
      { userAccountId: number; minorAccountId: number }
    >({
      query: ({ userAccountId, minorAccountId }) => ({
        url: `/Account/support/getmonthlyperformance/${userAccountId}/${minorAccountId}`,
      }),
      providesTags: (_result, _error, { userAccountId, minorAccountId }) => [
        { type: "Performance", id: `${userAccountId}-${minorAccountId}` },
        { type: "Beneficiary", id: minorAccountId.toString() },
      ],
    }),
  }),
});

export const {
  useGetIndividualBeneficiaryQuery,
  useGetBeneficiaryPerformanceQuery,
  useLazyGetIndividualBeneficiaryQuery,
  useLazyGetBeneficiaryPerformanceQuery,
} = beneficiaryApi;
